function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "titleTag", "linkProps", "imageSrc", "imageProps", "tagText", "children", "dateText", "locationText", "isFullHeight", "className", "companyLogo", "companyName", "logoProps"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import classNamesMaker from "classnames";
import { Text, TEXT_WEIGHTS } from "#library/components/Text/Text";
import { Tag } from "#library/components/Tag";
import { Signature } from "#library/components/Signature/Signature";
import { EventCardTopTag } from "#library/components/Card/cardComponents/EventCard/EventCardTopTag/EventCardTopTag";
import { EventCardLike } from "#library/components/Card/cardComponents/EventCard/EventCardLike/EventCardLike";
import { Card } from "#library/components/Card";
import { buildSlots } from "#library/utils/slots";
import { Logo } from "#library/components/Image/Logo";
import { BOX_SIZES } from "#library/components/Image/Image";
import { Icon } from "#library/components/Icon/Icon";
import { DATA_SPACER } from "#library/constants/enums";
import calendar from "#library/assets/icons/jds_calendar.svg";
import pin from "#library/assets/icons/jds_pin.svg";
import styles from "./eventCard.module.css";
var ALLOWED_SLOTS = {
  SIGNATURE: "Signature",
  TOPTAG: "TopTag",
  LIKE: "Like"
};
export var EventCard = function EventCard(props) {
  var title = props.title,
    _props$titleTag = props.titleTag,
    titleTag = _props$titleTag === void 0 ? "p" : _props$titleTag,
    linkProps = props.linkProps,
    imageSrc = props.imageSrc,
    imageProps = props.imageProps,
    tagText = props.tagText,
    children = props.children,
    dateText = props.dateText,
    locationText = props.locationText,
    _props$isFullHeight = props.isFullHeight,
    isFullHeight = _props$isFullHeight === void 0 ? false : _props$isFullHeight,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    companyLogo = props.companyLogo,
    companyName = props.companyName,
    logoProps = props.logoProps,
    restProps = _objectWithoutProperties(props, _excluded);
  var _buildSlots = buildSlots(children, Object.values(ALLOWED_SLOTS)),
    SignatureSlot = _buildSlots.SignatureSlot,
    TopTagSlot = _buildSlots.TopTagSlot,
    LikeSlot = _buildSlots.LikeSlot;
  var classNames = classNamesMaker(styles["jds-EventCard"], className);
  var hasLikeButton = !!LikeSlot;
  var customTagClassNames = classNamesMaker(styles["jds-EventCard__tag"], _defineProperty({}, styles["jds-EventCard__tag--withLikeButton"], hasLikeButton));
  var customTitleClassNames = classNamesMaker(styles["jds-EventCard__title--maxLines"], _defineProperty({}, styles["jds-EventCard__title--withLikeButton"], hasLikeButton));
  var informations = [{
    icon: "#".concat(calendar.id),
    text: dateText
  }, {
    icon: "#".concat(pin.id),
    text: locationText
  }];
  return /*#__PURE__*/React.createElement(Card, _extends({
    isFullHeight: isFullHeight,
    className: classNames
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-EventCard__inner"]
  }, /*#__PURE__*/React.createElement(Card.Header, {
    hasPadding: false,
    className: styles["jds-EventCard__header"]
  }, TopTagSlot, /*#__PURE__*/React.createElement(Card.Image, {
    imageProps: imageProps,
    src: imageSrc
  })), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-EventCard__wrapper"]
  }, /*#__PURE__*/React.createElement(Card.Body, null, LikeSlot, /*#__PURE__*/React.createElement(Tag, {
    size: "small",
    className: customTagClassNames
  }, tagText), /*#__PURE__*/React.createElement(Card.Title, {
    resetSpacing: true,
    as: titleTag,
    linkProps: linkProps,
    className: customTitleClassNames
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles["jds-EventCard__company"]
  }, /*#__PURE__*/React.createElement(Logo, _extends({
    src: companyLogo
  }, logoProps, {
    boxSize: BOX_SIZES.MEDIUM,
    alt: ""
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    weight: TEXT_WEIGHTS.BOLD
  }, companyName)), /*#__PURE__*/React.createElement("ul", {
    className: styles["jds-EventCard__information"]
  }, informations.map(function (information) {
    return /*#__PURE__*/React.createElement(Text, {
      tag: "li",
      className: styles["jds-EventCard__informationItem"],
      key: information.text
    }, /*#__PURE__*/React.createElement(Icon, {
      xlinkHref: information.icon,
      dataSpacer: DATA_SPACER.RIGHT_100,
      className: styles["jds-EventCard__informationIcon"]
    }), information.text);
  }))), SignatureSlot && /*#__PURE__*/React.createElement(Card.Footer, {
    hasDivider: false
  }, SignatureSlot))));
};
EventCard.Signature = Signature;
EventCard.Signature.slotName = ALLOWED_SLOTS.SIGNATURE;
EventCard.TopTag = EventCardTopTag;
EventCard.TopTag.slotName = ALLOWED_SLOTS.TOPTAG;
EventCard.Like = EventCardLike;
EventCard.Like.slotName = ALLOWED_SLOTS.LIKE;